import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SubProject } from 'src/app/model/project/sub-project';
import { AdminPlanningMapComponent } from '../../admin-planning-map/admin-planning-map.component';
import { RequestService } from 'src/app/services/request.service';
import { ProductTypeCriteriumService } from 'src/app/services/product-type-criterium-service';
import { EmployeeChoicesService } from 'src/app/services/employee-choices.service';
import { DirectionsCalculationService } from 'src/app/services/google-maps/directions-calculation.service';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import Address from 'src/app/model/project/address';

@Component({
  selector: 'daily-planning-map',
  templateUrl: './daily-planning-map.component.html',
  styleUrls: ['./daily-planning-map.component.scss'],
})
export class DailyPlanningMapComponent
  extends AdminPlanningMapComponent
  implements OnChanges
{
  private directionsRenderer = new google.maps.DirectionsRenderer({
    preserveViewport: true,
    suppressMarkers: true,
    suppressInfoWindows: true,
  });

  @Input()
  taskSubProjects: SubProject[];
  @Input()
  addresses: Address[];

  totalDistance: string;

  constructor(
    protected requestService: RequestService,
    protected productTypeCriteriumService: ProductTypeCriteriumService,
    protected employeeChoicesService: EmployeeChoicesService,
    private directionsCalculationService: DirectionsCalculationService
  ) {
    super(requestService, productTypeCriteriumService, employeeChoicesService);
  }

  // Override
  ngOnInit(): void {
    this.showSubmitPlanContent = false;
    this.processTaskSubProjects();
    this.processAddresses();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.taskSubProjects || changes.addresses) {
      this.setInit(false);
    }
    if (changes.taskSubProjects) {
      this.processTaskSubProjects();
    }
    if (changes.addresses) {
      this.processAddresses();
    }
  }

  // Override
  protected mapReady(): void {
    this.directionsRenderer.setMap(this.map);
  }

  private processTaskSubProjects(): void {
    this.subProjects = this.taskSubProjects;
    this.processSubProjects();
    this.setInit(true);
  }

  private processAddresses(): void {
    this.directionsRenderer.setDirections({
      geocoded_waypoints: [],
      routes: [],
    });
    if (CollectionHelper.isPopulated(this.subProjects)) {
      this.directionsCalculationService
        .calculateDirections(this.addresses)
        .then((result: google.maps.DirectionsResult) => {
          this.calculateTotalDistance(result);
          this.setDirections(result);
        })
        .catch((err) => console.error(err));
    }
    this.setInit(true);
  }

  private setDirections(directions: google.maps.DirectionsResult): void {
    this.directionsRenderer.setDirections(directions);
  }

  private calculateTotalDistance(result: google.maps.DirectionsResult): void {
    let total = 0;
    result.routes[0].legs.forEach((l) => {
      total += l.distance.value;
    });
    let roundedKm = (total * 0.001).toFixed(2);
    this.totalDistance = roundedKm.replace('.00', '').replace('.', ',') + ' km';
  }
}
